import { object, string } from 'yup'

const IP_RANGE_REGEX =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([1-9]|[1-2][0-9]|3[0-2]))$/

export const WHITELISTING_CLASSIFICATIONS = ['CDN', 'LICENSE', 'MULTI_USE_LOGIN']

export const whitelistingFormValidationSchema = object().shape({
  IPRange: string()
    .required('IP Range is required')
    .matches(
      IP_RANGE_REGEX,
      "Invalid CIDR range. When specifying a single IP use '/32' as suffix. See RFC 4632"
    ),
  classification: string()
    .oneOf(WHITELISTING_CLASSIFICATIONS)
    .required('Classification is required'),
  description: string().required('Description is required')
})
